import type { TranslateService } from '@ngx-translate/core';

export function buildToolsLabels(translate: Pick<TranslateService, 'instant'>) {
  const t = (key: string) => translate.instant(key);
  return {
    areasLabel: t('Map_areas_tr'),
    drawAreaLabel: t('Map_draw_area_tr'),
    editLabel: t('Map_edit_feature_tr'),
    deleteLabel: t('Map_delete_feature_tr'),
    addPointLabel: t('Map_add_point_tr'),
    removeAllLabel: t('Map_clear_all_tr'),
    listLabels: {
      search: t('Map_search_list_tr'),
      empty: t('Map_no_matches_tr'),
      whisp: {
        all: t('Map_whisp_filter_all_tr'),
        risk: t('whisp_status_RISK_tr'),
        ok: t('whisp_status_OK_tr'),
      },
    },
  };
}
